<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="parentx" v-if="$store.state.user._id">
<!--    <div v-if="showCloseButton" class="menu-trigger" onclick="isVerticalNavMenuActive = true"><span>MENU</span></div>-->
    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe">

      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave" class="h-100 d-flex column">

        <!-- Header -->
        <div class="header-sidebar flex items-end justify-between" slot="header">

          <!-- Logo -->
          <router-link @click.native="clearSearch" class="vx-logo cursor-pointer flex items-center" to="/" style="flex-direction: column; text-align: center; white-space: normal;">
            <!--<logo class="w-10 mr-4 fill-current text-primary" />-->
            <!--<span class="vx-logo-text text-primary" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span>-->
            <img src="/img/embibe-logo-amp.svg" style="max-height: 65px;margin-bottom: 15px" />
            <span class="vx-logo-text text-primary">Embibe Content Playroom</span>
          </router-link>
          <!-- /Logo -->

          <!-- Menu Buttons -->
          <div style="position: absolute; right: 10px; top: 10px;">
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon icon="XIcon" class="m-0 cursor-pointer" @click="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)" />
            </template>

          </div>
        </div>
        <!-- /Header -->
        <div v-if="$store.state.user.role.name !== 'Authenticated'">
          <div style="padding: 0 15px">
            <div class="flex items-center relative custom-container custom-search">
              <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                        placeholder="Search here"
                        @keypress.enter="search"
                        v-on:keyup="search2"
                        :value="$store.state.searchQuery" size="large"/>

              <div class="absolute top-0 right-0 px-4 d-flex items-center" style="height: 100%">
                <div slot="reset-icon" class="py-4 cursor-pointer" :class="{'flex': $store.state.searchQuery}" v-show="$store.state.searchQuery" style="padding-right: 0 !important;">
                  <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer" @click="searchQuery = '';$store.commit('setState', {searchQuery: ''}); search()"/>
                </div>
                <div slot="submit-icon" class="flex cursor-pointer" @click="search()" style="padding-right: 0 !important; position: relative">
                  <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" :class="{'active-search-btn': isLoading}" />
                  <div class="loader-block search-loader" v-if="isLoading">
                    <div class="loading">
                      <div class="effect-1 effects"></div>
                      <div class="effect-2 effects"></div>
                      <div class="effect-3 effects"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <div class="text-right px-2 py-1">
                  <router-link
                      to="/advanced-search"
                  >
                      <b><em>Advanced Search</em></b>
                  </router-link>
              </div>
          </div>
          <div class="w-full"
               style="display: flex; justify-content: center; flex-direction: column; padding: 0 15px; margin-top: 20px;" v-if="isAdvancedSearchPage">
            <vs-checkbox v-for="(item, index) in types" :key="index" :value="$store.state.typeFilters[item.value]"
                         @change="updateFilters(item.value)" style="margin-bottom: 10px">{{ item.name }}<template v-if="isAssetsCount">(<b>{{ item.count || 0 }}</b>)</template>
            </vs-checkbox>
          </div>
        </div>
        <GlobalSearchTip v-if="$store.state.user.role.name === 'Authenticated'" />
        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom" />

        <!-- Menu Items -->
        <component :is="scrollbarTag" class="pt-5 d-flex column h-auto" :key="$vs.rtl" style="overflow: unset !important;" v-if="$store.state.user.role.name !== 'Authenticated'">
          <template v-for="(item, index) in menuItemsUpdated">

            <!-- Group Header -->
            <span v-if="item.header && !verticalNavMenuItemsMin" class="navigation-header truncate" :key="`header-${index}`">
              {{ item.header }}
            </span>
            <!-- /Group Header -->
            <template v-else-if="!item.header">

              <template v-if="item.slug !== 'create' || $store.state.user.role.name === 'Media' || $store.state.user.role.name === 'Manager'">
                <!-- Nav-Item -->
                <v-nav-menu-item
                        @click.native="clearSearch"
                        v-if="!item.submenu && ((item.slug !== 'data-assets' && item.slug !== 'deleted-assets' && item.slug !== 'review-list') || $store.state.user.role.name === 'Manager')"
                        :key="`item-${index}`"
                        :index="index"
                        :to="item.slug !== 'external' ? item.url : null"
                        :href="item.slug === 'external' ? item.url : null"
                        :icon="item.icon" :target="item.target"
                        :isDisabled="item.isDisabled"
                        :slug="item.slug">
                  <span v-show="!verticalNavMenuItemsMin" class="truncate">{{ item.name }}</span>
                  <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip>
                </v-nav-menu-item>

                <!-- Nav-Group -->
                <template v-else>
                  <v-nav-menu-group
                          :key="`group-${index}`"
                          :openHover="openGroupHover"
                          :group="item"
                          :groupIndex="index"
                          :open="isGroupActive(item)" />
                </template>
              </template>

              <!-- /Nav-Group -->
            </template>
          </template>

        </component>
        <div class="custom-scroll-wrapper" v-if="$store.state.user.role.name !== 'Authenticated'">
          <div class="custom-scroll">
            <vs-collapse class="collapse menu-collapse">
              <vs-collapse-item>
                <div slot="header">
                  Other
                </div>
                <div>
                  <div class="custom-menu-item" v-for="(item, index) in customMenuItems" v-if="!item.roles || item.roles.indexOf($store.state.user.role.name) !== -1" :key="index">
                    <router-link :to="item.url">
                      {{ item.name }}
                    </router-link>
                  </div>
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>
        <!-- /Menu Items -->
        <div style="margin: auto 15px 20px 15px" >
          <template v-if="$store.state.user">
            <div>Email: {{ this.$store.state.user.email.replace('@embibe.com', '') }}</div>
            <div>Role: {{ this.$store.state.user.role.name }}</div>
          </template>
          <vs-button class="shadow-lg" color="primary" type="border" @click="logOut" style="margin-top: 5px;width: 100%">Log Out</vs-button>
        </div>
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area menu-trigger"
      v-hammer:swipe="onSwipeAreaSwipe" @click="isVerticalNavMenuActive = true">
      <span>MENU</span>
    </div>
    <!-- /Swipe Gesture -->
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VNavMenuGroup from './VerticalNavMenuGroup.vue'
import VNavMenuItem from './VerticalNavMenuItem.vue'

import Logo from "../Logo.vue"
import GlobalSearchTip from "@/components/GlobalSearchTip.vue";

export default {
  name: 'v-nav-menu',
  components: {
    GlobalSearchTip,
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo
  },
  props: {
    logo:             { type: String },
    openGroupHover:   { type: Boolean, default: false },
    parent:           { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems:     { type: Array,   required: true },
    title:            { type: String },
  },
    data() {
        return {
    clickNotClose       : false, // disable close navMenu on outside click
    isMouseEnter        : false,
    reduce              : false, // determines if navMenu is reduce - component property
    showCloseButton     : false, // show close button in smaller devices
    settings            : {      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed        : 1,
      swipeEasing       : true
    },
    showShadowBottom    : false,
    searchQuery: "",
    debounce: false,
    types: JSON.parse(JSON.stringify(this.$store.state.types)),
    is_test: false,
    is_empty: false,
    is_recently: false,
    isLoading: false,
    isAssetsCount: false,
    isAdvancedSearchPage: false,
    customMenuItems: [
      {
        url: '/?is_test=true',
        name: 'Test assets',
        slug: 'show_test_assets',
        icon: '',
        i18n: 'Email'
      },
      {
        url: '/?coobo_link_only=true',
        name: 'Coobo link w/o files',
        slug: 'coobo_link_only',
        icon: '',
        i18n: ''
      },
      {
        url: '/?is_empty=true',
        name: 'Empty assets',
        slug: 'show_empty_assets',
        icon: '',
        i18n: 'Chat'
      },
      {
        url: '/?is_recently=true',
        name: 'Recently created assets',
        slug: 'show_recently_created_assets',
        icon: '',
        i18n: 'Todo'
      },
      {
        url: '/duplicates',
        name: 'Duplicates',
        slug: 'duplicates',
        icon: '',
        i18n: 'Duplicates'
      },
      {
        url: '/data-assets',
        name: 'Data assets',
        slug: 'data-assets',
        icon: '',
        i18n: 'Data assets'
      },
      {
        url: '/deleted-assets',
        name: 'Deleted assets',
        slug: 'deleted-assets',
        icon: '',
        i18n: 'Deleted assets'
      },
      {
        url: '/review-list',
        name: 'Review list',
        slug: 'review-list',
        icon: '',
        i18n: 'Review list'
      },
      {
        url: '/asset-sequence',
        name: 'Asset sequence',
        slug: 'asset-sequence',
        icon: '',
        i18n: 'Asset sequence'
      },
      {
        url: '/translations',
        name: 'Translations',
        slug: 'translations',
        icon: '',
        i18n: 'Translations'
      },
      {
        url: '/user-actions',
        name: 'User actions',
        slug: 'user-actions',
        icon: '',
        i18n: 'User actions'
      },
      {
        url: '/bulk-publish',
        name: 'Bulk publish',
        slug: 'bulk-publish',
        icon: '',
        i18n: 'Bulk publish',
        roles: ['Manager']
      }
    ]
  }},
    beforeDestroy(){
        this.$root.$off('search_loading');
    },
  computed: {
    isGroupActive() {
      return (item) => {
        const path        = this.$route.fullPath
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined
        let open          = false

        let func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (item.url && (path === item.url || routeParent === item.slug)) { open = true }
              else if (item.submenu) { func(item) }
            })
          }
        }
        func(item)
        return open
      }
    },
    menuItemsUpdated() {
      let clone = this.navMenuItems.slice()

      for(let [index, item] of this.navMenuItems.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          let i = clone.findIndex(ix => ix.header === item.header)
          for(let [subIndex, subItem] of item.items.entries()) {
            clone.splice(i + 1 + subIndex, 0, subItem)
          }
        }
      }

      return clone
    },
    isVerticalNavMenuActive: {
      get()    { return this.$store.state.isVerticalNavMenuActive },
      set(val) { this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', val) }
    },
    layoutType() { return this.$store.state.mainLayoutType },
    reduceButton: {
      get()    { return this.$store.state.reduceButton },
      set(val) { this.$store.commit('TOGGLE_REDUCE_BUTTON', val) }
    },
    isVerticalNavMenuReduced() { return Boolean(this.reduce && this.reduceButton) },
    verticalNavMenuItemsMin()  { return this.$store.state.verticalNavMenuItemsMin },
    scrollbarTag()             { return this.$store.getters.scrollbarTag          },
    windowWidth()              { return this.$store.state.windowWidth             }
  },
  watch: {
    '$route'() {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
    },
    reduce(val) {
      const verticalNavMenuWidth = val ? "reduced" : this.$store.state.windowWidth < 800 ? "no-nav-menu" : "default"
      this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

      setTimeout(function() {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    },
    layoutType()   { this.setVerticalNavMenuWidth() },
    reduceButton() { this.setVerticalNavMenuWidth() },
    windowWidth()  { this.setVerticalNavMenuWidth() }
  },
  methods: {
      search() {
          if (this.$route.name !== 'advancedSearch') {
              let search = this.$store.state.searchQuery.trim();
              if (search) {
                  this.$router.push(`/advanced-search`)
              }
          } else {
            this.$root.$emit('update_advanced_search', '');
          }
      },
      search2(e) {
        if (e && e.target) {
          this.searchQuery = e.target.value;
          this.$store.commit("setState", {searchQuery: e.target.value});
        }
      },
      getSearchData(e) {
          if (e && e.target) {
              this.searchQuery = e.target.value;
              this.$store.commit("setState", {searchQuery: e.target.value});
          }

          if (this.$route.name === 'home' || this.$route.name === 'myLibrary') {
              clearTimeout(this.debounce)
              this.debounce = setTimeout(() => {
                  this.isLoading = true;
                  let search = this.$store.state.searchQuery.trim();
                  this.$root.$emit('update_search', '');
                  this.getAssetsTypesCounts();
              }, 1000)
          }
      },
      updateFilters(index) {
          let types = JSON.parse(JSON.stringify(this.$store.state.typeFilters));
          types[index] = !types[index];

          this.$store.commit("setState", {typeFilters: types});

          if (this.$route.name === 'advancedSearch') {
            this.$root.$emit('update_as_type_filters');
          } else {
            setTimeout(() => {
              this.getSearchData();
            }, 10);
          }
      },
      getAssetsTypesCounts() {
          this.isAssetsCount = true;
          let types = this.types;

          types.forEach(item => {
              let url = '/assets/adv-search?asset_types=' + JSON.stringify([item.value]) + '&isCountRequest=true';
              // if (!this.$store.state.searchQuery) {
              //     if (this.is_test) {
              //         url += '&is_test=' + true;
              //     }
              //     if (this.is_empty) {
              //         url += '&is_empty=' + true;
              //     }
              //     if (this.is_recently) {
              //         url += '&is_recently=' + true;
              //     }
              // }
              // if (this.$store.state.searchQuery) {
              //     url += '&_search=' + this.$store.state.searchQuery;
              // }
              // if (this.$route.name === 'myLibrary') {
              //     url += '&owner=' + this.$store.state.user.email;
              // }
              this.$axios.get(url).then(res => {
                  item.count = res.data
              }).catch(e => {
                  console.log('catch_search', e)
              })
          })
      },
      clearSearch() {
        this.searchQuery = "";
        this.$root.$emit("clearSearch")
      },
    logOut() {
        localStorage.removeItem('jwt');
        this.$router.push('/login');
        this.$store.commit("logout");
    },
    onMenuSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false
      }
      // Swipe Left
      else if (event.direction === 2 && !this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false
      }
    },
    onSwipeAreaSwipe(event) {

      // Swipe Right
      if (event.direction === 4 && !this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      }
      // Swipe Left
      else if (event.direction === 2 && this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      }
    },
    psSectionScroll() {
      const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs
      this.showShadowBottom = scroll_el.scrollTop > 0 ? true : false
    },
    mouseEnter() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)
      this.isMouseEnter = true
    },
    mouseLeave() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', true)
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {

      if(this.windowWidth > 800) {
        if(this.layoutType === 'vertical') {

          // Set reduce
          this.reduce = this.reduceButton ? true : false

          // Open NavMenu
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
          this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

          // Menu Action buttons
          this.clickNotClose   = true
          this.showCloseButton = false

          const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
          this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

          return
        }
      }

      // Close NavMenu
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      // Reduce button
      if (this.reduceButton) this.reduce = false

      // Menu Action buttons
      this.showCloseButton = true
      this.clickNotClose   = false

      // Update NavMenu Width
      this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      // Remove Only Icon in Menu
      this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)



      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val
      this.setVerticalNavMenuWidth()
    },
  },
  mounted() {
    this.isAdvancedSearchPage = this.$route.name === 'advancedSearch' || this.$route.name === 'advancedSearchNew';
    if (this.$route.query.search) {
        this.$store.commit("setState", {searchQuery: this.$route.query.search});
        this.isLoading = true;
    }
      if (this.$route.query.is_test) {
          this.is_test = this.$route.query.is_test;
      }
      if (this.$route.query.is_empty) {
          this.is_empty = this.$route.query.is_empty;
      }
      if (this.$route.query.is_recently) {
          this.is_recently = this.$route.query.is_recently;
      }
    this.setVerticalNavMenuWidth()

    if (this.$route.name === 'advancedSearch' || this.$route.name === 'advancedSearchNew' || this.$route.query.search) {
        this.getAssetsTypesCounts();
    }
    // if (this.$route.name == 'home') {
    //     this.isLoading = true;
    // }

    this.$root.$on('search_loading', (isLoading) => {
        this.isLoading = isLoading;
    })
  },
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss"
</style>
